import React from 'react';
import PropTypes from 'prop-types';

function LightboxViewHeadline(props) {
    const containerClassNames = ['lightbox-filter-view__headline-section', 'lightbox-filters-headline']
        .concat(props.additionalClassNames || [])
        .join(' ');

    return (
        <div className={containerClassNames}>
            <h2 className="lightbox-filters-headline__headline">{props.headline}</h2>
        </div>
    );
}

LightboxViewHeadline.propTypes = {
    headline: PropTypes.string.isRequired,
    additionalClassNames: PropTypes.array,
};

LightboxViewHeadline.defaultProps = {
    additionalClassNames: [],
};

export { LightboxViewHeadline };
